import { render, staticRenderFns } from "./login.vue?vue&type=template&id=1ad24d4c&scoped=true&lang=html&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad24d4c",
  null
  
)

export default component.exports